import React, { memo, useState, useCallback, useEffect } from 'react';
import classNames from 'classnames';
import { EmailConfirmPopup } from 'shared/components/EmailConfirmPopup';
import styles from './OneMany.module.scss';
import { OneManyTitle } from './components/OneManyTitle';
import { ActionForm } from './components/ActionForm';
import { ONE_MANY_KEY, TEXT } from './constants';
import { ONE_MANY_SORRY_TEXTS_MAIN } from '../OneManySorry/constants';
import { sendOneManyMiniEvent, sendOneManyMiniSubEvent } from './events';

export const OneMany = memo(function OneMany({ isSub = false }: { isSub?: boolean }) {
  const [isEmailPopupVisible, setIsEmailPopupVisible] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [isVisited, setIsVisited] = useState(false);

  const sorryTexts = isSub ? ONE_MANY_SORRY_TEXTS_MAIN.sub : ONE_MANY_SORRY_TEXTS_MAIN.free;

  useEffect(() => {
    document.title = TEXT.documentTitle;
  }, []);

  useEffect(() => {
    if (localStorage.getItem(ONE_MANY_KEY)) {
      setIsVisited(true);
      sendOneManyMiniEvent('GO_TO_LEND_ALREADY_REGISTERED');
    }
  }, [isSub]);

  useEffect(() => {
    if (!localStorage.getItem(ONE_MANY_KEY)) {
      if (!isSub) sendOneManyMiniEvent('VEB_REGISTRATION_ATTAND');
      else {
        sendOneManyMiniSubEvent('VEB_ATTAND');
      }
    }
  }, [isSub]);

  const handleSubmit = useCallback((email: string) => {
    sendOneManyMiniEvent('FILL_EMAIL', email);
    sendOneManyMiniEvent('SIGN_FREE_CLICK');
    setIsEmailPopupVisible(true);
    sendOneManyMiniEvent('GO_TO_CAPCHA');
    setIsSent(false);
  }, []);

  const handleClosePopup = useCallback(() => {
    setIsEmailPopupVisible(false);
    setIsSent(false);
    sendOneManyMiniEvent('CLOSE_CAPCHA_MODAL');
  }, []);

  const handleValidationSuccess = useCallback(() => {
    setIsSent(true);
  }, []);

  return (
    <div className={styles.main}>
      <div className={styles.oneManyWrap}>
        <OneManyTitle isSub={isSub} />
        <div className={styles.content}>
          <div className={styles.illustration} />
          <div
            className={classNames(
              styles.formWrap,
              isSub && !isVisited && styles.subForm,
              !isSub && !isVisited && styles.emailForm,
              isVisited && styles.visitedForm,
            )}
          >
            <ActionForm isSub={isSub} handleSubmit={handleSubmit} isVisited={isVisited} />
          </div>
        </div>
      </div>
      {isVisited && (
        <div className={styles.sorryTexts}>
          <p className={styles.firstText}>{sorryTexts.firstText}</p>
          <p className={styles.secondText}>{sorryTexts.secondText}</p>
        </div>
      )}
      <div className={styles.bottomLogo} />
      <EmailConfirmPopup
        isVisible={isEmailPopupVisible}
        isSent={isSent}
        onClose={handleClosePopup}
        onValidationSuccess={handleValidationSuccess}
        setIsVisited={setIsVisited}
      />
    </div>
  );
});
